/**
 * <Paragraph> — running-text encapsulation of <Text>.
 *
 * Pins the parent-design body preset: `text-base`, medium, running-text ink
 * (`text-primary`). Prefer it over the bare <Text>
 * for paragraph / label copy; override props only when a one-off needs it.
 */
import React from "react"

import { Text, type TextProps } from "../Text"

export type ParagraphProps = TextProps

export function Paragraph(props: ParagraphProps) {
    return <Text size="text-base" weight="medium" color="text-primary" {...props} />
}
